module.exports = __webpack_public_path__ + "static/assets/09ae5f141e47c952d6843314bb3bd5c5.svg";